import { FunctionComponent, ReactNode } from "react";

interface ImprintProps {}

interface SectionProps {
  title: string;
  children: ReactNode;
}

interface RowProps {
  label: string;
  children: ReactNode;
}

const Section: FunctionComponent<SectionProps> = ({ title, children }) => {
  return (
    <section className="flex w-full flex-col gap-4">
      <h2 className="font-GeistBold text-xl">{title}</h2>
      {children}
    </section>
  );
};

const Row: FunctionComponent<RowProps> = ({ label, children }) => {
  return (
    <div className="flex flex-col gap-1 border-b border-slate-200 py-3 sm:flex-row sm:gap-6 sm:py-2.5">
      <dt className="text-gray-500 sm:w-48 sm:shrink-0">{label}</dt>
      <dd className="m-0">{children}</dd>
    </div>
  );
};

const Imprint: FunctionComponent<ImprintProps> = () => {
  return (
    <main className="mx-auto my-[85px] flex w-full flex-col items-start justify-start px-4 pb-16 lg:w-1/3 lg:px-0">
      <header className="w-full text-left">
        <h1 className="font-GeistBold text-3xl">Impressum</h1>
        <p className="mt-2 text-gray-500">
          Angaben gemäß § 5 Digitale-Dienste-Gesetz (DDG)
        </p>
      </header>

      <hr className="my-6 h-[1px] w-full border-0 bg-slate-300" />

      <div className="flex w-full flex-col gap-10 text-base leading-relaxed">
        <Section title="Anbieter">
          <dl className="m-0 flex w-full flex-col">
            <Row label="Unternehmen">Juwelier Bucher GbR</Row>
            <Row label="Vertreten durch">
              die Gesellschafter Frank Bucher und Holger Bucher
            </Row>
            <Row label="Anschrift">
              <address className="not-italic">
                Weinholdstraße 33
                <br />
                08468 Reichenbach
                <br />
                Deutschland
              </address>
            </Row>
            <Row label="Telefon">
              <a
                href="tel:+49376512802"
                className="underline underline-offset-2"
              >
                0 37 65 / 1 28 02
              </a>
            </Row>
            <Row label="Telefax">0 37 65 / 71 97 27</Row>
            <Row label="E-Mail">
              <a
                href="mailto:info@juwelier-bucher.de"
                className="underline underline-offset-2"
              >
                info@juwelier-bucher.de
              </a>
            </Row>
            <Row label="Umsatzsteuer-ID">
              DE 209306711 (gemäß § 27a Umsatzsteuergesetz)
            </Row>
          </dl>
        </Section>

        <Section title="Verantwortlich für den Inhalt">
          <address className="not-italic">
            Frank Bucher und Holger Bucher
            <br />
            Weinholdstraße 33
            <br />
            08468 Reichenbach
          </address>
        </Section>

        <Section title="Verbraucherstreitbeilegung">
          <p>
            Wir sind nicht bereit und nicht verpflichtet, an
            Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
            teilzunehmen.
          </p>
        </Section>

        <Section title="FairCommerce">
          <p>
            Wir sind seit dem 23.07.2015 Mitglied der Initiative
            &quot;FairCommerce&quot;. Nähere Informationen finden Sie unter{" "}
            <a
              href="https://www.fair-commerce.de"
              target="_blank"
              rel="noopener noreferrer"
              className="underline underline-offset-2"
            >
              www.fair-commerce.de
            </a>
            .
          </p>
        </Section>
      </div>
    </main>
  );
};

export default Imprint;
